import React from 'react';
import SettingDisplayCredential from "./settingDisplayCredential";
import SettingDisplayPaymentMethod from "./settingDisplayPaymentMethod";


export default function SettingDisplay({value, settingType}) {
    if (settingType === 'boolean') {
        return <span>{value ? 'Yes' : 'No'}</span>;
    }
    if (settingType === 'number') {
        return <span>{value}</span>;
    }
    if (settingType === 'json') {
        try {
            const parsedValue = JSON.parse(value);
            return <pre>{JSON.stringify(parsedValue, null, 2)}</pre>;
        } catch (e) {
            return <span>Error parsing JSON</span>;
        }
    }
    if (settingType === 'credential') {
        return <SettingDisplayCredential value={value}/>;
    }
    if (settingType === 'payment_method') {
        return <SettingDisplayPaymentMethod value={value}/>;
    }
    if (settingType === 'html') {
        return <div className="overflow-auto border-1 border-opacity-25 border overflow-scroll" style={{height: 200}}>
            <div dangerouslySetInnerHTML={{ __html: value }} />
        </div>
    }

    return <span>{value}</span>;
}